export class Sprint {
    id: number;
    title: string;
    start_date: string;
    end_date: string;
    working_days: number;
    description: string;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/models/sprint.ts